import type { FunctionComponent } from 'react'
import { Translation } from '../../contexts/TranslationContext'
import { Container } from './Container'
import style from './DidYouKnowBar.module.sass'

type DidYouKnowBarProps = {
	text: string
}

export const DidYouKnowBar: FunctionComponent<DidYouKnowBarProps> = ({ text }) => {
	return (
		<div className={style.wrapper}>
			<Container size="wide" disableGutters>
				<div className={style.body}>
					<h3 className={style.title}>
						<Translation tr="didYouKnow.title" />
					</h3>
					<div className={style.content}>{text}</div>
				</div>
			</Container>
		</div>
	)
}
